import styled from 'styled-components';

export const IconInput = styled.div`
  display: flex;
`;

export const Icon = styled.div`
  display: flex;
  align-items: center;
  width: 24px;
  margin-right: 0.5rem;
`;

export const Input = styled.div`
  flex: 1;
`;

export const ForgotPassword = styled.div`
  display: flex;
  justify-content: end;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 8rem);
`;
